import { Component, Input } from '@angular/core';
import { RouterLink } from "@angular/router";
import {
  EntityNameNumberRecordComponent
} from '@shared/components/commons/entity-name-number-record/entity-name-number-record.component';
import { ACNPipe } from "@shared/pipes/acnPipe";
import { getCompanyProfilePath } from "@shared/utils/route-path-utils";
import { ICellRendererAngularComp } from "ag-grid-angular";
import { ICellRendererParams } from "ag-grid-community";
import { CompanyRecord } from "@models/companies/company-record";

type CellRendererParams = ICellRendererParams<CompanyRecord>;

@Component({
  selector: 'app-ag-company-name-acn',
  standalone: true,
  imports: [
    RouterLink,
    ACNPipe,
    EntityNameNumberRecordComponent,
  ],
  templateUrl: './ag-company-name-acn.component.html',
  styleUrl: './ag-company-name-acn.component.scss'
})
export class AgCompanyNameAcnComponent implements ICellRendererAngularComp {
  @Input() name = '';
  @Input() acn = '';
  @Input() companyProfilePageLink: string[] | null = null;

  agInit(params: CellRendererParams): void {
    this.updateCell(params);
  }

  refresh(params: CellRendererParams): boolean {
    return this.updateCell(params);
  }

  updateCell(params: CellRendererParams): boolean {
    this.companyProfilePageLink = params.data?.entityId ? getCompanyProfilePath(params.data?.entityId) : null;
    this.name = params.data?.name ?? '';
    this.acn = params.data?.acn ?? '';
    return true;
  }
}
